<template>
  <div class='loading'>
    <img src='@/assets/images/ui/loading.gif' />
    <div>
      <span v-text='isRequestingCAM ? "CALCULATING" : "LOADING"'></span>
      <span v-if='isRequestingCAM'>{{ $t('この処理はデータ量に応じて数分 ~ 15分ほどかかる場合があります。') }}</span>
      <button class="btn" v-if='cancellable' @click="$emit('cancel')">{{ $t('キャンセル') }}</button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    isRequestingCAM: {
      type: Boolean,
      default: false
    },
    cancellable: {
      type: Boolean,
      default: false
    }
  }
};

</script>

<style lang="scss" scoped>

@import '@/assets/styles/_button-style.scss';

.loading {
  z-index: 10000;
  pointer-events: none;

  position: absolute;
  top: 0%;
  left: 0%;

  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);

  display: flex;
  align-items: center;
  justify-content: center;

  img {
    display: block;
    width: 92px;
    margin-bottom: 20px;
    position: absolute;
  }

  & > div {
    display: block;
    margin-top: 160px;
  }

  span {
    display: block;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #fff;
  }

  button {
    pointer-events: auto;
    cursor: pointer;
    display: block;
    @include button-style();
    margin-top: 8px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/viewer/LoadingIndicator.vue